import { c as _c } from "react/compiler-runtime";
import { Alert } from '@navikt/ds-react';
import { store } from '@/app/_components/store/store';
export const IngenTreff = () => {
  const $ = _c(3);
  const {
    tekst
  } = store.useReducerState();
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = {
      marginTop: 24
    };
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] !== tekst.filter.ingenTreff) {
    t1 = <Alert variant="info" role="status" style={t0}>{tekst.filter.ingenTreff}</Alert>;
    $[1] = tekst.filter.ingenTreff;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  return t1;
};